var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import { Box, Container, Flex, forwardRef, useStyleConfig, } from "@chakra-ui/react";
import { useScrollbarInfo } from "../../hooks";
export const AppBar = forwardRef((_a, ref) => {
    var { position = "fixed", sx, color = "primary", children } = _a, rest = __rest(_a, ["position", "sx", "color", "children"]);
    const styles = useStyleConfig("AppBar");
    const { hasYScrollbar, yScrollbarWidth } = useScrollbarInfo();
    return (React.createElement(React.Fragment, null,
        React.createElement(Flex, { position: position, sx: {
                width: "100%",
                zIndex: 5,
                flexShrink: 0,
                flexDirection: "column",
                top: 0,
                right: 0,
                left: "auto",
            } },
            React.createElement(Flex, Object.assign({ __css: styles, ref: ref, sx: Object.assign({ pr: hasYScrollbar ? 0 : yScrollbarWidth }, sx), backgroundColor: color }, rest),
                React.createElement(Container, null,
                    React.createElement(Flex, { sx: {
                            alignItems: "center",
                            flex: 1,
                            position: "relative",
                        } }, children)))),
        React.createElement(Box, { __css: styles })));
});
